
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import {serviceTabs} from "@/utils/tabs";
import {ServiceStore} from "@/store/modules/Services";
import {IServicesListItem} from "@/entity/services/services.types";
import {message} from "ant-design-vue";
import {RouterNameEnum} from "@/router/router.types";
import ServiceGeneralFormComponent from "@/UI/components/forms/serviceGeneral/ServiceGeneralForm.vue";
import ServiceGeneralForm from "@/form/serviceGeneral/serviceGeneral";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import { IServicesCategory } from "@/entity/servicesCategory/services.category.types";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import {IPosition} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import {SalaryStore} from "@/store/modules/Salary";
import {StatusesStore} from "@/store/modules/Status";
import {PositionStore} from "@/store/modules/Position";
import {CategoryStore} from "@/store/modules/Category";
import {WorkersStore} from "@/store/modules/Workers";
import WorkerAddForm from "@/form/workerAdd/workerAdd";
import { checkUserRole, getUserData } from '@/router/Lib/helper';

import { ICms_Category } from "@/entity/staff/staff.types";

import moment from 'moment';
import { getStudioId } from "@/UI/lib/state";

@Component({
  components: {PageTitle, ServiceGeneralFormComponent, FormGroup},
  methods: {moment}
})
export default class ServicePartnerDetail extends Vue {

  tabs = serviceTabs;
  form = new ServiceGeneralForm();
  formReady = false;
  studio_id = getStudioId(this)

  constructor() {
    super();
    moment().locale(this.$i18n.locale);
  }
  workerForm = new WorkerAddForm();
  worker: IWorkersListItem | null = null;

  get service(): IServicesListItem | null {
    return ServiceStore.services;
  }

  addTabRole() {
    if (Vue.auth.check('network')) {
      this.tabs = [
        {
          id: RouterNameEnum.ServiceDetailWorkers,
          name: i18nText("Сотрудники")
        },
        {
            id: RouterNameEnum.ServiceDetailProducts,
            name: i18nText("Расходники")
        },
        {
            id: RouterNameEnum.ServiceDetailDocuments,
            name: i18nText("Документы")
        },
      ]
    }
  }

  get servicesCategory(): IServicesCategory | null {
    return ServicesCategoryStore.serviceCategory;
  }

  async editService(): Promise<void> {
    if (await this.form.submit(ServiceStore.update)) {
      await ServicesCategoryStore.fetchAll();
      this.form = new ServiceGeneralForm();
      await this.$router.push({name: this.$routeRules.Services})
    }
  }

  get staffLoaded(): boolean {
    return WorkersStore.workersLoaded;
  }
  get staff(): IWorkers | null {
    return WorkersStore.workers;
  }
  get positions(): IPosition[] {
    return PositionStore.position;
  }
  get statuses(): IStatus[] {
    return StatusesStore.status;
  }
  get categories(): ICms_Category[] {
    return CategoryStore.category;
  }
  get salary(): ISalaryScheme[] {
    return SalaryStore.salary;
  }

  // get service_cosmetologists(): IServiceCosmetologists | null{
  //     return ServiceCosmetologistsStore.serviceCosmetologist;
  // }

  async created(): Promise<void> {
    //await ServiceCosmetologistsStore.fetchAll();
    const Role = checkUserRole();
    const UserData = getUserData();
    this.addTabRole()
    let filter: {[k: string]: any} = {
      limit: 20,
      filter: {'salon_id': null, 'id': null}
    };

    if(Role == 'owner' && UserData && UserData.studios)
    {
      filter.filter.salon_id = UserData.studios;
    } else if(this.$store.state.salon_id) {
      filter.filter.salon_id = this.$store.state.salon_id;
    }

    await ServiceStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    //await ServiceStore.fetchData({filter: {id: parseInt(this.$route.params.id)}});
    delete filter.filter['id'];
    await ServicesCategoryStore.fetchAll({limit: 200});
    await WorkersStore.fetchAll(filter);
    await StatusesStore.fetchAll();
    await CategoryStore.fetchAll();
    await PositionStore.fetchAll();
    await SalaryStore.fetchAll();
    // await ServiceCosmetologistsStore.fetchAll();

    this.formReady = true;

    if (this.service) {
      this.workerForm.setFormDataWithoutId(this.positions, this.categories, this.statuses, this.salary);
      this.form.setFormData(this.service);
    }
  }

  handleTimeChange(value: any): void {
    this.form.service_duration = value.format('HH:mm');
    this.update();
  }

  async update(): Promise<void> {
    this.form.service_id = parseInt(this.$route.params.id);
    if(await this.form.submit(ServiceStore.update)) {
      //this.created;
    }
  }

  async deleteService(): Promise<void> {
    if(await  ServiceStore.delete({id: parseInt(this.$route.params.id)})) {
      message.success(i18nText("Данные успешно удалены"));
      await this.$router.push({name: RouterNameEnum.PartnerServices, params: {Studio: getStudioId(this)}});
    } else {
      message.error(i18nText("Что то пошло не так..."))
    }
  }

  tabChanged(key: string): void {
    this.$router.push({name: key});
  }
}
